import stylex from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: anatomy['size-8'],
    padding: ' 16px 24px 16px ',
  },
  stepsContainer: {
    position: 'absolute',
    left: '24px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: anatomy['size-12'],
  },
  stepInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  step: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  info: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
  },
  nextStep: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    lineHeight: typography['lineHeightBody-5'],
  },
  statsWrapper: {
    display: 'flex',
    padding: '0 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  statsContent: {
    display: 'flex',
    padding: '16px 0',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--space-12, 12px)',
    alignSelf: 'stretch',
  },
  information: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: '16px',

    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-3'],
  },
  groupStats: {
    display: 'flex',
    padding: 'var(--space-no, 0)',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--space-4, 4px)',
    alignSelf: 'stretch',
  },
  groupStatsTitle: {
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    alignSelf: 'stretch',
  },
  groupStatsText: {
    overflow: 'hidden',
    color: 'var(--foreground-secondary, #61666C)',
    textOverflow: 'ellipsis',
    fontFamily: 'DIN 2014',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '20px',
  },
  groupStatsEmailBlock: {
    display: 'flex',
    padding: 'var(--space-no, 0)',
    alignItems: 'flex-start',
    gap: 'var(--space-4, 4px)',
    alignSelf: 'stretch',
    lineHeight: '20px',
  },
  groupStatsEmail: {
    display: 'flex',
    width: '44px',
    alignItems: 'center',
    gap: '10px',
  },
  groupStatsEmailTitle: {
    color: 'var(--foreground-tertiary, #8E9296)',
    fontFamily: 'DIN 2014',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
  },
  groupStatsEmailLine: {
    display: 'flex',
    width: '120px',
    paddingTop: 'var(--space-16, 16px)',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--space-no, 0)',
    // position: 'relative',

    backgroundImage: `repeating-linear-gradient(
      to right,
      ${colors.tertiaryBorder} 0 6px,  
      transparent 6px 10px             
    )`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom',
    backgroundSize: '100% 1px',
  },
  groupStatsEmailCount: {
    display: 'flex',
    padding: 'var(--space-no, 0)',
    alignItems: 'flex-start',
    gap: 'var(--space-4, 4px)',
    flex: '1 0 0',
    color: colors.primaryText,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  dateWrapper: {
    display: 'flex',
    padding: 'var(--space-16, 16px) 0',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--space-12, 12px)',
    alignSelf: 'stretch',
  },
  dateInviteTitle: {
    display: 'flex',
    padding: 'var(--space-no, 0)',
    alignItems: 'flex-start',
    gap: 'var(--space-4, 4px)',
    alignSelf: 'stretch',
  },
  dateInviteText: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  datePeriodText: {
    color: 'var(--foreground-tertiary, #8E9296)',
    fontFamily: 'DIN 2014',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    width: '120px',
  },
  dateLine: {
    display: 'flex',
    width: '44px',
    paddingTop: 'var(--space-16, 16px)',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--space-no, 0)',

    backgroundImage: `repeating-linear-gradient(
      to right,
      ${colors.tertiaryBorder} 0 6px,  
      transparent 6px 10px             
    )`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom',
    backgroundSize: '100% 1px',
  },
  datePeriod: {
    display: 'flex',
    width: '260px',
    padding: 'var(--space-no, 0)',
    alignItems: 'flex-start',
    gap: 'var(--space-4, 4px)',

    color: 'var(--foreground-primary, #1D252D)',
    fontFamily: 'DIN 2014',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
  },
  alertContainer: {
    display: 'flex',
    padding: 'var(--space-16, 16px)',
    alignItems: 'flex-start',
    gap: 'var(--space-8, 8px)',
    alignSelf: 'stretch',
    borderRadius: 'var(--border-radius-m, 12px)',
    background: 'var(--Background-Info, #EDF2FD)',
  },
  alertText: {
    color: 'var(--foreground-primary, #1D252D)',
    fontFamily: 'DIN 2014',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    width: '372px',
  },
});
